<template>
  <div>
    <AreaLine :id="id" :chartData="chartData" />
  </div>
</template>

<script>
  import AreaLine from "@/components/Highcharts/Lvyouyulun/AreaLine.vue";

  export default {
    name: "Yuqingbianhuaqushi",
    props: {
      chartData: {
        type: Object,
        default() {
          return {};
        }
      },id: {
        type: String,
        default: "chart"
      }
    },
    components: {
      AreaLine
    },
    data() {
      return {};
    },
    mounted() {
    }
  };
</script>

<style scoped lang="less"></style>
